import React from 'react'
import { Input } from '../../Login/Components/UI/Input'
import { Button } from '../../Login/Components/UI/Button'


export const PersonalInfoStep = ({ 
  formData, 
  errors, 
  touched, 
  onChange, 
  onBlur, 
  onNext 
}) => {
  const handleSubmit = (e) => {
    e.preventDefault()
    onNext()
  }

  return (
    <form onSubmit={handleSubmit} className="space-y-5">
      <div className="flex flex-col gap-4">
        <div>
          <label htmlFor="first_name" className="block text-xs font-medium text-gray-700 mb-1">
            First Name
          </label>
          <Input
            id="first_name"
            name="first_name"
            type="text"
            value={formData.first_name}
            onChange={onChange}
            onBlur={onBlur}
            placeholder="First name"
            error={errors.first_name}
            touched={touched.first_name}
          />
          {errors.first_name && touched.first_name && (
            <p className="mt-1 text-xs text-red-600">{errors.first_name}</p>
          )}
        </div>
        
        <div>
          <label htmlFor="last_name" className="block text-xs font-medium text-gray-700 mb-1">
            Last Name
          </label>
          <Input
            id="last_name"
            name="last_name"
            type="text"
            value={formData.last_name}
            onChange={onChange}
            onBlur={onBlur}
            placeholder="Last name"
            error={errors.last_name}
            touched={touched.last_name}
          />
          {errors.last_name && touched.last_name && (
            <p className="mt-1 text-xs text-red-600">{errors.last_name}</p>
          )}
        </div>
      </div>

      <div>
        <label htmlFor="email" className="block text-xs font-medium text-gray-700 mb-1">
          Email Address
        </label>
        <Input
          id="email"
          name="email"
          type="email"
          value={formData.email}
          onChange={onChange}
          onBlur={onBlur}
          placeholder="Your email address"
          error={errors.email}
          touched={touched.email}
        />
        {errors.email && touched.email && (
          <p className="mt-1 text-xs text-red-600">{errors.email}</p>
        )}
      </div>

      <div>
        <Button type="submit">
          Continue
        </Button>
      </div>
    </form>
  )
}